<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-finanziamenti page-operative-data-analysis-finanziamenti-edit">
    <div class="container">
      <PageTitle>Modifica finanziamento</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Finanziamento da modificare non trovato</div>
      <FormFinanziamento v-else-if="company && userCanEdit" :finanziamento.sync="finanziamento" edit @saved="saveFinanziamento" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-finanziamenti-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormFinanziamento: () => import('@/views/components/Operative/Form/FormFinanziamento'),
  },
  data () {
    return {
      finanziamento: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveFinanziamento (finanziamento) {
      this.$api.updateFinanziamento(this.company.id, finanziamento.id, finanziamento)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.finanziamenti',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getFinanziamento(this.company.id, this.$route.params.finanziamentoId)
          .then(res => {
            this.finanziamento = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
